import React from 'react';
import { IntervalTiming } from './intervalTiming';
import { CountDown } from './countDown';
import { FromNow } from './fromNow';
import { jsx as _jsx } from "react/jsx-runtime";
const Day = props => {
  return /*#__PURE__*/_jsx("div", {});
};
Day.IntervalTiming = IntervalTiming;
Day.CountDown = CountDown;
Day.FromNow = FromNow;
export default Day;